import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Check",
  "use": "Check-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Check\">\r\n<g clip-path=\"url(#Check_clip0_7272_287285)\">\r\n<path d=\"M13.5002 24.255L7.24523 18L5.11523 20.115L13.5002 28.5L31.5002 10.5L29.3852 8.38501L13.5002 24.255Z\" fill=\"#3A3A3A\" stroke=\"#3A3A3A\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"Check_clip0_7272_287285\">\r\n<rect width=\"36\" height=\"36\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol